<template>
  <div class="footer">
    <div class="info">
      <div class="w">
        <div class="lfetCon">
          <div class="link">
            <div v-for="(item, i) in linkGroup" :key="i">
              <el-select
                v-model="link[i]"
                :placeholder="link[i].label"
                @change="
                  (val) => {
                    tolink(val, i);
                  }
                "
                popper-class="linkSelect"
              >
                <el-option
                  v-for="(el, ind) in item"
                  :key="ind"
                  :label="el.label"
                  :value="ind"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="quickLinks">
            <div
              v-for="(item, i) in quickLink"
              :key="i"
              @click="pathJumpb(item)"
            >
              {{ item.label }}
            </div>
          </div>
          <div class="beian">
            <!-- <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011702000733"
               style="display:flex;align-items:center;text-decoration:none;height:20px;line-height:20px;"><img
              :src="require('../../assets/images/gongan.png')" style="float:left;"/> -->
            <!-- <p class="p-bar" style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;position: relative">鄂公网安备
                42011702000733号</p></a> -->
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              ><span style="color: #939393">鄂ICP备2023029374号-1 </span></a
            >
          </div>
          <div class="copy">
            <span
              >COPYRIGHT © 2023-{{
                nowYear()
              }}
              长江数联物流信息（湖北）股份有限公司 ALL RIGHTS RESERVED</span
            >
            <!-- <span>增值电信业务经营许可证：鄂B2-20200098</span> -->
          </div>
        </div>
        <div class="ewm">
          <!-- <div class="tips-all">
            <div class="tips">
              <router-link to="/websitestated"> 网站声明</router-link>
            </div>
            <div class="tips">
              <router-link to="/mesuggestions"> 建议反馈</router-link>
            </div>
            <div class="tips-iph"><i class="el-icon-phone-outline"></i> 400-0998-326</div>
          </div> -->
          <div class="code-info">
            <img
              :src="require('../../assets/images/code1.jpg')"
              style="width: 120px; height: 120px; border-radius: 8px"
            />
            <div class="tips-all">
              <!-- <div class="tips-iph"><i class="el-icon-phone-outline"></i> 400-0998-326</div> -->
              <div class="tips-iph">小程序</div>
            </div>
          </div>
          <div class="code-info">
            <img
              :src="require('../../assets/images/publiccode.jpg')"
              style="width: 120px; height: 120px; border-radius: 8px"
            />
            <div class="tips-all">
              <div class="tips-iph">公众号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NewsCenter",
  computed: {
    // swiper() {
    //     return this.$refs.mySwiper.swiper;
    // }
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      link: [
        { label: "政府职能部门", value: "0" },
        { label: "物流公共信息平台", value: "1" },
        { label: "合作企业", value: "1" },
        { label: "其他相关网站", value: "3" },
      ],
      linkGroup: [
        [
          {
            label: "湖北省发展和改革委员会",
            value: "1",
            path: "https://fgw.hubei.gov.cn/",
          },
          {
            label: "湖北省交通运输厅",
            value: "2",
            path: "https://jtt.hubei.gov.cn/",
          },
          {
            label: "湖北省市场监管局",
            value: "3",
            path: "https://scjg.hubei.gov.cn/",
          },
          {
            label: "湖北省地方金融监督管理局",
            value: "4",
            path: "http://dfjrjgj.hubei.gov.cn/",
          },
          {
            label: "湖北省商务厅",
            value: "5",
            path: "http://swt.hubei.gov.cn/",
          },
          {
            label: "中华人民共和国武汉海关",
            value: "6",
            path: "http://wuhan.customs.gov.cn/",
          },
        ],
        [
          {
            label: "国家交通信息物流公共信息服务平台",
            value: "1",
            path: "https://www.logink.cn/",
          },
          {
            label: "四川省物流公共信息平台",
            value: "2",
            path: "https://www.scswl.cn/",
          },
          {
            label: "辽宁省物流公共信息平台",
            value: "3",
            path: "http://www.lns56.com/",
          },
          {
            label: "江西省物流公共信息平台",
            value: "4",
            path: "http://jtwl.jxjt.gov.cn/",
          },
        ],
        [
          {
            label: "湖北港口集团有限公司",
            value: "1",
            path: "http://www.hubeiport.com/",
          },
          {
            label: "湖北联投集团有限公司",
            value: "2",
            path: "http://www.hbslft.com/",
          },
          {
            label: "湖北交通投资集团有限公司",
            value: "3",
            path: "http://www.hbjttz.com/",
          },
          {
            label: "湖北宏泰集团有限公司",
            value: "4",
            path: "https://www.hbhtgroup.com/",
          },
          {
            label: "湖北机场集团有限公司",
            value: "5",
            path: "http://www.hbairport.com/",
          },
          {
            label: "湖北省数字产业发展集团有限公司",
            value: "6",
            path: "http://www.hbscjt.com.cn/",
          },
          {
            label: "湖北交投物流集团有限公司",
            value: "7",
            path: "http://www.hbjtwlpt.com/exp/door/index.htm",
          },
          {
            label: "湖北省征信有限公司",
            value: "8",
            path: "https://www.hubeizhengxin.com/home/",
          },
          { label: "湖北机场集团信息科技有限公司", value: "9", path: "" },
        ],
        [
          { label: "中国铁路95306", value: "1", path: "http://www.95306.cn/" },
          {
            label: "中国铁路运输协会",
            value: "2",
            path: "https://www.cctaw.cn/",
          },
          {
            label: "中国物流信息中心",
            value: "3",
            path: "http://www.clic.org.cn/",
          },
        ],
      ],
      quickLink: [
        // {label: '政务服务', path: '/government'},
        {
          label: "综合物流",
          // href: 'https://wl.hbgyl.com.cn/dsly',
          loginhref:
            "https://login.hbgyl.com.cn/outside/oauth2/authorize?response_type=code&appId=c4bf0b43-e8d7-423b-b137-b6995c252c42&redirect_uri=https://wl.hbgyl.com.cn",
          href: "https://wl.hbgyl.com.cn/multimodalTransport",
          csloginhref:
            "http://cs-login.hbgyl.com.cn/outside/oauth2/authorize?response_type=code&appId=294321fa-03a3-4b97-8170-cb17afb1b6e6&redirect_uri=https://cs-wl.hbgyl.com.cn/login",
          cshref: "https://cs-wl.hbgyl.com.cn/multimodalTransport",
          m_code: "ZHWL",
        },
        {
          label: "在线贸易",
          // label: '集采招标',
          // href: 'https://ds.hbgyl.com.cn/mtweb/index.html',
          loginhref:
            "https://ds.hbgyl.com.cn/gdpaas/comp/sso/login.htm?re_url=https://ds.hbgyl.com.cn/mtweb/index.html",
          href: "https://ds.hbgyl.com.cn/mtweb/index.html",
          // href:'https://jc.hbgyl.com.cn/bidcms/index.html',
          csloginhref:
            "https://cs-ds.hbgyl.com.cn/gdpaas/comp/sso/login.htm?re_url=https://cs-ds.hbgyl.com.cn/mtweb/index.html",
          cshref: "https://cs-ds.hbgyl.com.cn/mtweb/index.html",
          m_code: "ZXMY",
        },
        {
          label: "供应链金融",
          // href: 'https://jr.hbgyl.com.cn/api',
          loginhref:
            "https://login.hbgyl.com.cn/login?appId=092b6441-d3bb-4a58-9697-607f447966e1&redirect_uri=https://gyljr.hbgyl.com.cn/scm/home&response_type=code",
          href: "https://gyljr.hbgyl.com.cn/scm/home",
          csloginhref:
            "https://cs-login.hbgyl.com.cn/login?appId=092b6441-d3bb-4a58-9697-607f447966e1&redirect_uri=https://cs-gyljr.hbgyl.com.cn/scm/home&response_type=code",
          cshref: "https://cs-gyljr.hbgyl.com.cn/scm/home",
          m_code: "GYJR",
        },
        {
          label: "政策惠企",
          path: "/government",
          m_code: "ZCHQ",
        },
        {
          label: "大数据中心",
          // href: "https://sj.hbgyl.com.cn/sjfw/",
          loginhref:
            "https://login.hbgyl.com.cn/login?response_type=code&appId=46008f3b-36e4-4c0d-ae0b-2eab85517ceb&redirect_uri=https://sj.hbgyl.com.cn/chain/login/oauth2/code/test",
          href: "https://sj.hbgyl.com.cn/sjfw/",
          csloginhref:
            "https://cs-login.hbgyl.com.cn/login?response_type=code&appId=46008f3b-36e4-4c0d-ae0b-2eab85517ceb&redirect_uri=https://cs-sj.hbgyl.com.cn/chain/login/oauth2/code/test",
          cshref: "https://cs-sj.hbgyl.com.cn/sjfw/",
          m_code: "SJZX",
        },
        { label: "应用中心", path: "/supplychain", m_code: "YYZX" },
        // {label: '帮助中心', path: '/helpCenter'},
        // {label: '网站声明', path: '/websitestated'},
        // {label: '反馈意见', path: '/mesuggestions'},
      ],
    };
  },

  created() {},

  methods: {
    tolink(e, i) {
      const path = this.linkGroup[i][e].path;
      if (path !== "") {
        window.open(path);
      }
    },
    pathJumpb(obj) {
      this.$pvuv.getEvent(obj.m_code);
      if (process.env.NODE_ENV === "testing") {
        if (obj.csloginhref) {
          if (Object.keys(this.userInfo).length == 0) {
            window.open(obj.cshref, "_blank");
          } else {
            window.open(obj.csloginhref, "_blank");
            // if(obj.label=='大数据中心'){
            //     if(this.userInfo.customizeValues == 1 || this.userInfo.customizeValues == 3){

            //        window.open(obj.csloginhref,'_blank')
            //     }else{
            //      this.$message({
            //         message: '当前账号无权限，请升级为企业用户！',
            //         type: 'warning'
            //       });
            //     }
            // }else{
            //   window.open(obj.csloginhref,'_blank')
            // }
          }
        } else if (obj.path) {
          const p = this.$router.resolve(obj.path);
          window.open(p.href, "_blank");
          window.location.reload();
          // this.$router.push(obj.path)
        }
      } else {
        if (obj.loginhref) {
          if (Object.keys(this.userInfo).length == 0) {
            window.open(obj.href, "_blank");
          } else {
            window.open(obj.loginhref, "_blank");
            // if(obj.label=='大数据中心'){
            //     if(this.userInfo.customizeValues == 1 || this.userInfo.customizeValues == 3){

            //        window.open(obj.loginhref,'_blank')
            //     }else{
            //      this.$message({
            //         message: '当前账号无权限，请升级为企业用户！',
            //         type: 'warning'
            //       });
            //     }
            // }else{
            //   window.open(obj.loginhref,'_blank')
            // }
          }
        } else if (obj.path) {
          const p = this.$router.resolve(obj.path);
          window.open(p.href, "_blank");
          window.location.reload();
          // this.$router.push(obj.path)
        }
      }
    },
    nowYear() {
      // 获取当前年份
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>
<style scoped lang="less">
.footer {
  // position: absolute;
  // bottom:0px;
  // right: 0;
  // left: 0;
  // box-sizing: border-box;
  padding: 18px 0 20px;
  background: url("../../assets/images/home-v2/BottomBackground.png");
  background-size: 100% 100%;
}

.link {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    width: 200px;

    /deep/ .el-select {
      width: 100%;

      .el-input__inner {
        height: 36px;
        line-height: 36px;
        background-color: rgba(28, 35, 49, 0.5);
        color: rgba(255, 255, 255, 0.6);
        border-color: transparent;
      }
    }
  }
}

.info {
  .w {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .lfetCon {
      width: 74%;

      .quickLinks {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        display: flex;
        div {
          font-size: 16px;
          font-weight: 500;
          color: #808695;
          line-height: 34px;
          padding: 0 20px;
          position: relative;
          cursor: pointer;
        }
        div:hover {
          color: #fff;
          opacity: 1;
        }

        div:after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
          background: #808695;
        }
      }

      .quickLinks div:last-child:after,
      .quickLinks div:nth-child(6):after {
        width: 0;
      }

      .beian {
        display: flex;
        align-items: center;
        justify-content: left;
        margin-top: 12px;
        img {
          margin-right: 10px;
        }

        .line {
          display: block;
          width: 1px;
          height: 16px;
          background: #dddddd;
          margin: 0 20px;
          opacity: 0.6;
        }

        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          line-height: 20px;
        }
        .p-bar:after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          right: -3%;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
          background: #808695;
        }
      }

      .copy {
        margin-top: 12px;

        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          line-height: 20px;
        }

        span:first-child {
          margin-right: 25px;
        }
      }
    }

    .ewm {
      // align-self: end;
      // margin-top: 20px;
      display: flex;
      //  flex-direction: column;
      align-items: center;
      // justify-content: space-between;
      gap: 28px;
      .code-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 3px;
      }
      .tips-iph {
        // margin-top: 10px;
        padding: 0px 10px;
        // background: #386CE8;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        border-radius: 8px;
      }
    }
    .tips-all {
      // padding: 16px 16px 0 0;
      // margin-right: 16px;
    }
    .tips {
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      cursor: pointer;
    }
    .tips a {
      color: rgba(255, 255, 255, 0.6);
    }
    .tips:hover {
      opacity: 0.78;
    }
  }
}

@media (min-width: 320px) and (max-width: 750px) {
  .link {
    flex-wrap: wrap;

    > div {
      width: 46vw;
      margin-bottom: 10px;

      /deep/ .el-select {
        width: 100%;

        .el-input__inner {
          font-size: 12px;
          height: 30px;
          line-height: 30px;
        }

        .el-input__icon {
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }

  .info {
    .w {
      flex-direction: column;

      .lfetCon {
        width: 100%;

        .quickLinks {
          width: 100%;
          box-sizing: border-box;
          padding: 20px 0 25px;

          a {
            display: inline-block;
            width: 25%;
            font-size: 12px;
            text-align: center;
            padding: 0;
          }

          a:after {
            height: 8px;
          }
        }

        .quickLinks a:last-child:after,
        .quickLinks a:nth-child(4n):after {
          width: 0;
        }

        .beian {
          flex-wrap: wrap;
          justify-content: center;

          img {
            margin-right: 5px;
          }

          .line {
            display: none;
          }

          span {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .copy {
          margin-top: 6px;
          display: flex;
          flex-wrap: wrap;

          span {
            font-size: 12px;
            line-height: 18px;
          }

          span:first-child {
            margin-right: 12px;
          }
        }
      }

      .ewm {
        margin-top: 10px;

        > div {
          margin-top: 5px;
          padding: 3px 5px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot_nav/index.vue